import action from '../../../abstract/action.js';

export default action({
  label: 'Edytuj',
  icon: 'EditIcon',
  main: () => true,
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'admin-kh-templates-edit', params: { id } }),
});
